// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1PI8S","title":"ClientInsurance_title__1K07G","itemText":"ClientInsurance_itemText__3Vx6N"};